module.exports = __webpack_public_path__ + "assets/models/violin.9819ecd195bd382f693acf23c1a051e7.glb";